<template>
  <v-text-field
    :class="isBorderOn ? '_border' : ''"
    hidden
    readonly
    flat
    light
    :error-messages="message"
  />
</template>

<script>
export default {
  name: 'ErrorMessage',
  props: {
    message: {
      required: true
    },
    isBorderOn: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border: unset
}

._border .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border: inherit;
}
</style>
